import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Feedback from '../pages/Feedback';


function Example() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button variant="btn orange-color circule" onClick={handleShow}>
        Submit Feedback
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Submit Feedback Form</Modal.Title>
        </Modal.Header>
        <Modal.Body>


          <Feedback />


        </Modal.Body>

      </Modal>
    </>
  );
}

export default Example;